/**
 * @file   详情
 * @create macaiqi 2025/06/16
 * @update
 */
import React, { useEffect, useState, useRef } from "react";
// import Header from "../Header";
// import Footer from "../Footer";
import { useLocation } from "react-router-dom";
import { queryArchivesById, queryFileList } from "../../../service";
import { useNav } from "../../../App";
// import Bread from "../Bread";
// import NavBar from "../NavBar";
import { flattenChannels } from "../../../utils/platform";
import QyqwHeader from "../Component/QyqwHeader";
import "./index.scss";
import UsePictureSlide from "./container/usePictureSlide";
import back from "../../../assets/images/back.png";

const PDFItem = ({ pdfdata }) => {
  const [show, setShow] = useState();
  return (
    <div className="pdf">
      <i
        className=""
        onClick={() => {
          setShow("pdfdata");
        }}
      ></i>
      {show === "pdfdata" && (
        <div className="common-page">
          <iframe
            src={`/pdfjs/web/viewer.html?file=${pdfdata?.[0]?.filePath}`}
            title="pdf"
            frameBorder={0}
          />
          <img
            src={back}
            className="back"
            alt=""
            onClick={() => {
              setShow();
            }}
          />
        </div>
      )}
    </div>
  );
};
export default function Detail() {
  let { pathname } = useLocation();
  const { navData2 } = useNav();

  const id = pathname?.split("/")?.reverse()?.[0];

  const channelNo =
    pathname?.split("/").length > 3
      ? pathname?.split("/")?.reverse()?.[2]
      : pathname?.split("/")?.reverse()?.[1];
  const flattenedChannels = flattenChannels(navData2);

  let channeldata = flattenedChannels?.filter((item) => {
    return item.channelNo === channelNo;
  })?.[0];
  const [data, setData] = useState();
  const [filedata, setFileData] = useState([]);
  const [pdfdata, setPdfdata] = useState();
  const [musicdata, setMusicdata] = useState();
  const [loading, setloading] = useState(true);

  const [isPlaying, setIsPlaying] = useState(false); // 琴曲-音频播放
  const audioRef = useRef(null);
  useEffect(() => {
    if (id) {
      setloading(true);
      queryArchivesById(id).then((res) => {
        setData(res);
        queryFileList({
          pagination: {
            size: 0,
            page: 0,
          },
          params: {
            groupId: res?.groupId,
            code: "CMS_ARCHIVES_FILE",
          },
        }).then((res1) => {
          //  判断文件扩展名是否为图片格式或音乐
          let imageExtensions = /(jpg|jpeg|png|gif|bmp|svg|webp|tif|tiff)$/i;
          setPdfdata(
            res1?.records?.filter((item) => {
              return item.type === "pdf";
            }) || []
          );
          setMusicdata(
            res1?.records?.filter((item) => {
              return item.type === "mp3";
            }) || []
          );
          setFileData(
            res1?.records?.filter((item) => {
              return imageExtensions.test(item.type);
            }) || []
          );
          setloading(false);
        });
      });
    }
  }, [id]);

  const togglePlayPause = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return (
    <>
      {/* <Header /> */}

      <QyqwHeader title={channeldata?.channelName} />
      <div className="detail-page gqwh-page">
        {/* {window.isWap && <NavBar title={channeldata?.["channelName"]} />} */}
        <div className="content">
          {/* {!window.isWap && <Bread title={channeldata?.['channelName']} path={pathname.substring(0, pathname.lastIndexOf('/'))} secondtitle={data?.title} />} */}

          <div className="main">
            {data?.imgSrc && (
              <div className="limg">
                {!loading && (
                  <UsePictureSlide
                    list={[
                      {
                        id: id,
                        title: data?.title,
                        filePath: data?.imgSrc?.includes("http")
                          ? data?.imgSrc
                          : window.ENV_IMG_PREURL + data?.imgSrc,
                      },
                      ...filedata?.filter((a) => {
                        return a.type !== "mp3";
                      }),
                    ]}
                    loading={loading}
                  />
                )}
              </div>
            )}
            <div className="r">
              <div className="top">
                <div className="rbtn">
                  {musicdata?.length > 0 && (
                    <div className="music">
                      <audio
                        ref={audioRef}
                        src={musicdata?.[0]?.filePath}
                      ></audio>
                      <i
                        className={isPlaying ? "stop" : "play"}
                        onClick={togglePlayPause}
                      ></i>
                    </div>
                  )}
                  {pdfdata?.length > 0 && <PDFItem pdfdata={pdfdata} />}
                </div>

                <p>
                  {/* <span className="span1">
                    {channelNo === "QHXZ-MustRead"
                      ? "曲目名称"
                      : channelNo === "GQSelectedTrack"
                      ? ""
                      : "标题"}
                  </span> */}
                  <span>{data?.title}</span>
                </p>
                {data?.subTitle && (
                  <p>
                    <span className="span1">演奏者</span>
                    <span>{data?.subTitle}</span>
                  </p>
                )}
                {data?.extension2 && (
                  <p>
                    <span className="span1">
                      琴谱
                      {/* {channelNo === "Qinqu"
                        ? "琴谱"
                        : channelNo === "Qinpu"
                        ? "年代"
                        : channelNo === "Guqin"
                        ? "尺寸"
                        : "出版时间"} */}
                    </span>
                    <span>{data?.extension2}</span>
                  </p>
                )}
                {data?.extension3 && (
                  <p>
                    <span className="span1">
                      演奏古琴
                      {/* {channelNo === "Qinqu"
                        ? "演奏古琴"
                        : channelNo === "Qinpu"
                        ? "收录琴曲数量"
                        : channelNo === "Guqin"
                        ? "形制"
                        : "出版社"} */}
                    </span>
                    <span>{data?.extension3}</span>
                  </p>
                )}
                {data?.extension4 && (
                  <p>
                    <span className="span1">现藏地点</span>
                    <span>{data?.extension4}</span>
                  </p>
                )}
              </div>
              {data?.content && (
                <div className="des">
                  {/* <p>
                    <span className="span1">简介</span>
                  </p> */}

                  <div
                    className="txt"
                    dangerouslySetInnerHTML={{ __html: data?.content }}
                  ></div>
                  {data?.abstract && (
                    <div className="abstract">
                      {pathname?.includes("Book") && (
                        <p className="t2">
                          <span className="span1">目录</span>
                        </p>
                      )}
                      <div
                        className="txt"
                        dangerouslySetInnerHTML={{ __html: data?.abstract }}
                      ></div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
}
